import { lighten, OPA_30 } from '../themeUtils.js';

export function led(ctx) {
    return {
        styles: {
            main: {
                bg_color:     ctx.primary,
                bg_opa:       255,
                border_width: 2,
                border_color: lighten(ctx.primary, OPA_30),
                radius:       999,
            },
        },
    };
}
